import React from 'react';
import { InventoryItem } from '../../lib/types';

interface Props {
  view: 'items' | 'history';
  inventory: InventoryItem[];
  lowStockCount: number;
  todayTransactions: number;
  weekIssued: number;
  weekReturned: number;
}

export function InventoryStatCards({
  view, inventory, lowStockCount, todayTransactions, weekIssued, weekReturned,
}: Props) {
  const barStyle: React.CSSProperties = {
    display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10,
    padding: 0, marginBottom: 12, background: 'transparent',
  };
  const headerRow: React.CSSProperties = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 };
  const iconBox = (bg: string): React.CSSProperties => ({ width: 28, height: 28, background: bg, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' });

  if (view === 'items') {
    return (
      <div className="stats-bar" style={barStyle}>
        <div className="sc cg">
          <div style={headerRow}>
            <div className="sl">SKUs tracked</div>
            <div style={iconBox('var(--teal-bg)')}>
              <svg viewBox="0 0 16 16" style={{ width: 14, height: 14, fill: 'none', stroke: 'var(--teal)', strokeWidth: 1.3 }}><rect x="2" y="5" width="12" height="9" rx="2"/><path d="M5 5V3.5C5 2.7 5.7 2 6.5 2h3c.8 0 1.5.7 1.5 1.5V5"/></svg>
            </div>
          </div>
          <div className="sn">{inventory.length}</div>
        </div>
        <div className="sc cb">
          <div style={headerRow}>
            <div className="sl">Total issued</div>
            <div style={iconBox('var(--blue-bg)')}>
              <svg viewBox="0 0 16 16" style={{ width: 14, height: 14, fill: 'none', stroke: 'var(--blue)', strokeWidth: 1.3 }}><path d="M4 8h8M9 5l3 3-3 3"/></svg>
            </div>
          </div>
          <div className="sn">{inventory.reduce((s, i) => s + i.issued, 0)}</div>
        </div>
        <div className={`sc ${lowStockCount > 0 ? 'cr' : 'cg'}`}>
          <div style={headerRow}>
            <div className="sl">Low stock</div>
            <div style={iconBox(lowStockCount > 0 ? 'var(--red-bg)' : 'var(--teal-bg)')}>
              <svg viewBox="0 0 16 16" style={{ width: 14, height: 14, fill: 'none', stroke: lowStockCount > 0 ? 'var(--red)' : 'var(--teal)', strokeWidth: 1.5 }}><path d="M8 3l6 10H2z" strokeLinejoin="round"/><path d="M8 8v1.5" strokeLinecap="round"/><circle cx="8" cy="11.5" r="0.5" fill="currentColor"/></svg>
            </div>
          </div>
          <div className="sn">{lowStockCount}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="stats-bar" style={barStyle}>
      <div className="sc cn">
        <div style={headerRow}>
          <div className="sl">Transactions today</div>
          <div style={iconBox('var(--surface2)')}>
            <svg viewBox="0 0 16 16" style={{ width: 14, height: 14, fill: 'none', stroke: 'var(--text2)', strokeWidth: 1.3 }}><circle cx="8" cy="8" r="6"/><path d="M8 5v3.5l2.5 1.5"/></svg>
          </div>
        </div>
        <div className="sn">{todayTransactions}</div>
      </div>
      <div className="sc cg">
        <div style={headerRow}>
          <div className="sl">Issued this week</div>
          <div style={iconBox('var(--blue-bg)')}>
            <svg viewBox="0 0 16 16" style={{ width: 14, height: 14, fill: 'none', stroke: 'var(--blue)', strokeWidth: 1.3 }}><path d="M4 8h8M9 5l3 3-3 3"/></svg>
          </div>
        </div>
        <div className="sn">{weekIssued}</div>
      </div>
      <div className="sc">
        <div style={headerRow}>
          <div className="sl">Returned this week</div>
          <div style={iconBox('var(--purple-bg)')}>
            <svg viewBox="0 0 16 16" style={{ width: 14, height: 14, fill: 'none', stroke: 'var(--purple)', strokeWidth: 1.3 }}><path d="M12 8H4M7 11l-3-3 3-3"/></svg>
          </div>
        </div>
        <div className="sn" style={{ color: weekReturned > 0 ? 'var(--purple)' : 'var(--text)' }}>{weekReturned}</div>
      </div>
    </div>
  );
}
